import { NotificationManager } from 'react-notifications';
import { ADD_NOTIFICATION, TOGGLE_READ } from '../actions/notificationsActions';

const initialState = {
    notifications: []
};

const notifications = (state = initialState, action) => {
    switch (action.type) {
        case ADD_NOTIFICATION:
            let title = "";
            switch (action.status) {
                case 400:
                    title = "Chyba klienta: Špatný požadavek!";
                    NotificationManager.error(action.message, title, 3000);
                    break;
                case 401:
                    title = "Chyba klienta: Nedostatečná oprávnění!";
                    NotificationManager.error(action.message, title, 3000);
                    break;
                case 404:
                    title = "Chyba klienta: Adresa nenalezena!";
                    NotificationManager.error(action.message, title, 3000);
                    break;
                case 409:
                    title = "Chyba klienta: Konflikt!";
                    NotificationManager.error(action.message, title, 3000);
                    break;
                case 500:
                    title = "Chyba serveru: Interní chyba serveru!";
                    NotificationManager.error(action.message, title, 3000);
                    break;
                case 501:
                    title = "Chyba serveru: Neimplementováno!";
                    NotificationManager.error(action.message, title, 3000);
                    break;
                case 502:
                    title = "Chyba serveru: Špatná brána!";
                    NotificationManager.error(action.message, title, 3000);
                    break;
                case 503:
                    title = "Chyba serveru: Služba je nedostupná!";
                    NotificationManager.error(action.message, title, 3000);
                    break;
                case 504:
                    title = "Chyba serveru: Vypršel časový limit brány!";
                    NotificationManager.error(action.message, title, 3000);
                    break;
                case 505:
                    title = "Chyba serveru: Verze HTTP není podporována!";
                    NotificationManager.error(action.message, title, 3000);
                    break;
                default:
                    switch (action.messageType) {
                        case 'welcome':
                            title = 'Vítejte';
                            NotificationManager.info(action.message, title, 3000);
                            break;
                        case 'success':
                            title = "Úspěch:";
                            NotificationManager.success(action.message, title, 3000);
                            break;
                        case 'info':
                            title = 'Info:';
                            NotificationManager.info(action.message, title, 3000);
                            break;
                        case 'warning':
                            title = 'Varování:';
                            NotificationManager.warning(action.message, title, 3000);
                            break;
                        case 'error':
                            title = "Chyba!";
                            NotificationManager.error(action.message, title, 3000);
                            break;
                        default:
                            title = "Info zpráva";
                            NotificationManager.info(action.message, title, 3000);
                            break;
                    }
            }
            return Object.assign({}, state, {
                notifications: [
                    ...state.notifications,
                    {
                        messageType: action.messageType,
                        title: title,
                        message: action.message,
                        time: new Date().toLocaleTimeString(),
                        read: false
                    }
                ]
            });

        case TOGGLE_READ:
            return Object.assign({}, state, {
                notifications: state.notifications.map((notification, index) => {
                    if (index === action.index) {
                        return Object.assign({}, notification, {
                            read: !notification.read
                        })
                    }
                    return notification;
                })
            });

        default:
            return state
    }
};

export default notifications;



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/notificationsReducer.js
 **/